export default "https://wallet.startwaves.co//alert.mp4";